module.exports = __webpack_public_path__ + "img/pc.b5bc4634.jpg";